export default __webpack_public_path__ + "static/media/100_1240.64457788.jpg";